import { memo, useCallback, useState } from "react";
import { Link } from "react-router-dom";

const CloseIcon = () => (
	<svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
		<path
			d="M6 6l12 12M18 6 6 18"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
		/>
	</svg>
);

const ChevronIcon = ({ up = false }) => (
	<svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
		<path
			d={up ? "m6 15 6-6 6 6" : "m6 9 6 6 6-6"}
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

function Menu({ menu, setMenu, items }) {
	const [openCategory, setOpenCategory] = useState(null);

	const closeMenu = useCallback(() => {
		setOpenCategory(null);
		setMenu(false);
	}, [setMenu]);

	const toggleCategory = useCallback((category) => {
		setOpenCategory((currentCategory) =>
			currentCategory === category ? null : category
		);
	}, []);

	if (!menu) return null;

	return (
		<>
			<button
				type="button"
				onClick={closeMenu}
				className="fixed inset-0 z-[9998] bg-black/35 lg:hidden"
				aria-label="Close mobile menu"
			/>

			<aside
				className="fixed left-0 top-0 z-[9999] h-screen w-[300px] overflow-y-auto bg-white shadow-xl lg:hidden"
				aria-label="Mobile navigation"
			>
				<div className="flex items-center justify-between border-b border-gray-100 p-6">
					<span className="font-lora text-2xl text-gray-800">Menu</span>
					<button
						type="button"
						onClick={closeMenu}
						className="rounded-full p-2 transition hover:bg-gray-100"
						aria-label="Close mobile menu"
					>
						<CloseIcon />
					</button>
				</div>

				<ul className="flex flex-col gap-5 px-8 py-8 font-lora">
					<li>
						<Link to="/" onClick={closeMenu} className="font-medium transition hover:text-pink-700">
							Home
						</Link>
					</li>

					{items.map((item) => {
						const isOpen = openCategory === item.category;
						return (
							<li key={item.category}>
								<button
									type="button"
									onClick={() => toggleCategory(item.category)}
									className="flex w-full items-center justify-between font-medium transition hover:text-pink-700"
									aria-expanded={isOpen}
								>
									{item.title}
									<ChevronIcon up={isOpen} />
								</button>

								{isOpen && (
									<ul className="ml-4 mt-3 flex flex-col gap-3 border-l border-pink-100 pl-4 font-poppins text-sm">
										{item.options.map((option) => (
											<li key={option.value}>
												<Link
													to={option.value}
													aria-label={option.ariaLabel}
													onClick={closeMenu}
													className="block transition hover:text-pink-700"
												>
													{option.label}
												</Link>
											</li>
										))}
									</ul>
								)}
							</li>
						);
					})}

					<li>
						<Link to="/about" onClick={closeMenu} className="font-medium transition hover:text-pink-700">
							About Us
						</Link>
					</li>
					<li>
						<Link to="/contact" onClick={closeMenu} className="font-medium transition hover:text-pink-700">
							Contact Us
						</Link>
					</li>
					<li className="pt-2">
						<a
							href="https://market.monsiniprom.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-block rounded-md border border-pink-700 px-4 py-2 font-bold text-pink-700"
						>
							Retailer Login
						</a>
					</li>
				</ul>
			</aside>
		</>
	);
}

export default memo(Menu);
